import { useTranslations } from "../hooks/useTranslations";
import { useMe } from "../http/serviceportalApi";
import QuestionnaireTab from "./questionnaire/QuestionnaireTab";
import Page from "./ui/Page";

const EconomicAdvisorQuestionnaire = () => {
  const { i18n } = useTranslations();
  const { data, isValidating } = useMe();

  return (
    <Page
      title={i18n.economicAdvisorApp.questionnaire.title}
      description={
        <>
          <p>{i18n.economicAdvisorApp.questionnaire.description.paragraph1}</p>
          <p>{i18n.economicAdvisorApp.questionnaire.description.paragraph2}</p>
          <p>{i18n.economicAdvisorApp.questionnaire.description.paragraph3}</p>
          <p>{i18n.economicAdvisorApp.questionnaire.description.paragraph4}</p>
        </>
      }
      isLoading={isValidating}
    >
      <QuestionnaireTab luid={data?.economicAdvisor?.luid!} />
    </Page>
  );
};

export default EconomicAdvisorQuestionnaire;
